import React from "react";
import * as PRIVACY_POLICY from "../../../content/pages/privacyPolicy.json";
import { marked } from "marked";

marked.setOptions({
  breaks: true, // turns \n into <br>
});

export class PrivacyPolicy extends React.Component<{}, {}> {
  componentDidMount() {
    //   const markdown = require("../../../content/site" + name);
  }

  render() {
    const data = PRIVACY_POLICY;

    const cleanedBody = data.body.replace(/\\\n/g, "\n");
    const markdownParsed = marked.parse(cleanedBody);
    return (
      <div className="flex-1 relative flex flex-col pt-[230px]">
        <div
          className="custom flex flex-col max-w-[750px] ml-auto mr-auto"
          dangerouslySetInnerHTML={{ __html: markdownParsed }}
        ></div>
      </div>
    );
  }
}
